module.exports = __webpack_public_path__ + "media/images/Whatsapp-line-d22e7bea.svg";